(() => {
  'use strict';
  const norm = value => String(value ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function context() {
    const node=document.querySelector('[data-stb-product-context]');
    if(!node)return null;
    try{return JSON.parse(node.textContent);}catch{return null;}
  }
  function selectedVariant() {
    const c=context();if(!c)return null;
    const input=document.querySelector('[data-stb-variant]');
    const id=input?.value || c.selected_variant;
    return c.product.variants.find(v=>String(v.id)===String(id)) || null;
  }
  function matchVariant(constraints) {
    const c=context();if(!c)return null;
    const options=c.product.options.map(o=>typeof o==='string'?o:o.name);
    const map=Object.entries(constraints).map(([key,aliases])=>{
      const keys=key.split('|').map(norm);
      let i=options.findIndex(o=>keys.includes(norm(o)));
      if(i<0 && options.length===1 && norm(options[0])==='title' && keys.includes('size'))i=0;
      return {index:i,aliases:aliases.map(norm)};
    });
    if(map.some(m=>m.index<0))return null;
    return c.product.variants.find(v=>map.every(m=>m.aliases.includes(norm(v['option'+(m.index+1)] ?? v.options?.[m.index])))) || null;
  }
  function money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.STBRoutes?.currency||'USD'}).format(Number(cents)/100);}
  function priceState(button,priceEl,variant){
    if(priceEl)priceEl.textContent=variant?money(variant.price):'Unavailable';
    button.disabled=!variant?.available;
    button.textContent=variant?.available?'ADD TO CART — '+money(variant.price):'CURRENTLY UNAVAILABLE';
  }
  async function add(variant,properties={},button){
    if(!variant?.available)throw new Error('This option is currently unavailable.');
    if(button)button.disabled=true;
    const root=window.STBRoutes?.root||'/';
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1,properties:Object.fromEntries(Object.entries(properties).filter(([,v])=>v!==undefined&&v!==null).map(([k,v])=>[k,String(v)]))}]})});
    let result;try{result=await response.json();}catch{throw new Error('We could not add this item. Please try again.');}
    if(!response.ok)throw new Error(result.description||result.message||'Could not add this item.');
    window.location.assign(window.STBRoutes?.cart||'/cart');
    return result;
  }
  function requestQuote(details){
    try{sessionStorage.setItem('stbQuoteDetails',String(details));}catch{}
    window.location.assign(window.STBRoutes?.contact||'/pages/contact-us');
  }
  function flagVariant(s){
    const c=context();if(!c)return null;
    const sizes={small:['Small','The Patriot','Small - The Patriot'],medium:['Medium','The Freedom','Medium - The Freedom'],large:['Large','The Liberty','Large - The Liberty']};
    const constraints={'Style|Flag Style|Shape':s.style==='hanging'?['Hanging','Draped','Hanging / Draped']:[s.style],'Size|Flag Size':sizes[s.size]||[]};
    if(c.product.options.some(o=>['letteringtreatment','letteringtype'].includes(norm(typeof o==='string'?o:o.name))))constraints['Lettering Treatment|Lettering Type']=s.letterType==='raised'?['Raised Wood']:['Painted'];
    return matchVariant(constraints);
  }
  window.STBCommerce={context,selectedVariant,matchVariant,money,priceState,add,requestQuote,flagVariant,norm};
})();
